import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  align-self: center;
`

export const TextBoldViolet = styled.p<{ isDisabled?: boolean; isClicked?: boolean }>`
  font-family: 'Public Sans', sans-serif;
  font-size: 0.85rem;
  font-style: normal;
  font-weight: 700;
  color: ${(props) => (props.isDisabled || props.isClicked ? '#999999' : '#C6016B')};
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  margin: 0;
`

interface IRow {
  width?: string
}

export const RowContainer = styled.div<IRow>`
  width: ${(props: IRow) => props.width || 'auto'};
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 999px;
  transition: background-color 0.18s ease, transform 0.18s ease;

  &:hover {
    background: rgba(45, 116, 156, 0.08);
    transform: translateY(-1px);
  }
`

export const TextBoldBlue = styled.p<{ isItemSelected?: boolean; isDisabled?: boolean }>`
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 0.85rem;
  color: ${(props) => (props.isDisabled ? '#A9A9A9' : '#2D749C')};
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  margin: 0;
  opacity: ${(props) => (props.isItemSelected ? 0.5 : 1)};
`

export const DisassociateText = styled.p`
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 0.8rem;
  color: #e44646;
  cursor: pointer;
  margin: 0;
`

export const DeleteText = styled.p`
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #e44646;
  cursor: pointer;
  margin: 0;
`

export const ContainerActionItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: auto;
  cursor: pointer;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 999px;
  transition: background-color 0.18s ease, transform 0.18s ease;

  &:hover {
    background: rgba(198, 1, 107, 0.08);
    transform: translateY(-1px);
  }
`

interface IRow {
  width?: string
  marginLeft?: string
}

export const Row = styled.div<IRow>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  width: ${(props: IRow) => props.width || '100%'};
  margin-left: ${(props: IRow) => props.marginLeft || '0px'};
`

export const DisabledBoldText = styled.p`
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 0.85rem;
  color: #999999;
  cursor: not-allowed;
  margin-left: 6px;
`

export const ContainerActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 10px;
`

export const TextInterpretation = styled.p`
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #c6016b;
  cursor: pointer;
  margin: 0;
`

export const ActionCell = styled.td`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0 10px;
`

export const ActionCellWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  min-width: 220px;
  gap: 8px;
`
